import { createContext, useContext, useEffect, useState } from "react";

// Lille, selvstændig theme-provider: holder "light"/"dark", gemmer valget i
// localStorage, og sætter data-theme på <html>, så al CSS i App.css (som
// bruger var(--...)-tokens) automatisk følger med. Ingen andre afhængigheder,
// så den kan wrappes helt yderst i main.jsx uden at påvirke routing/auth.

const STORAGE_KEY = "offlist_theme";

const ThemeContext = createContext({
  theme: "light",
  toggleTheme: () => {},
  setTheme: () => {},
});

function getInitialTheme() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "light" || stored === "dark") return stored;
  } catch (e) {
    /* localStorage utilgængelig (f.eks. privat browsing) — falder tilbage */
  }
  try {
    if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
      return "dark";
    }
  } catch (e) {}
  return "light";
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {}
  }, [theme]);

  const toggleTheme = () => setThemeState((prev) => (prev === "dark" ? "light" : "dark"));
  const setTheme = (next) => setThemeState(next === "dark" ? "dark" : "light");

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
